import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { environment } from './environments/environment';

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { STALE_CHUNK_ERROR_PATTERNS } from '@core/utils/stale-chunk.util';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry.dsn,
  environment: environment.sentry.environment,
  normalizeDepth: 5,
  ignoreErrors: [
    // Handled in-app by VersionService with a reload prompt.
    ...STALE_CHUNK_ERROR_PATTERNS,
    // A fetch() that failed at the network layer: backgrounded tab, lost
    // connection, aborted request. Each engine words it differently, so all
    // four spellings are the same non-actionable event. These come from code
    // that calls fetch() directly (DevExpress analytics-core, auth0-js) -
    // Angular's HttpClient is XHR-based here and surfaces HttpErrorResponse
    // instead.
    /^Load failed/, // Safari / WebKit
    /^Failed to fetch/, // Chrome, Edge
    /^NetworkError when attempting to fetch resource/, // Firefox
    /^network error$/, // WebKit, older builds
    /^The network connection was lost/, // iOS Safari
    /^cancelled$/, // iOS Safari, request aborted mid-flight
    /: 0 Unknown Error$/,
    /\[Status: 0\]/,
  ],
  beforeSend: (event) => {
    if (
      !environment.sentry.enabled ||
      window.location.href.includes('localhost')
    ) {
      // Console error message when developing
      console.error(event.message);
      return null;
    }
    return event;
  },
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
